<div
  class="side-nav"
  [class.side-nav--collapsed]="!isExpanded()"
  #sidenav
  (mouseenter)="toggleOverlay(true)"
  (mouseleave)="toggleOverlay(false)"
>
  <div class="side-nav__loading-overlay" [class.visible]="isLoading()">
    <app-loader [size]="isExpanded() ? 48 : 24" />
  </div>

  @for (item of sideNavItems(); track item.id) {
    @if (!!item.category && isExpanded()) {
      <p class="side-nav__item-category">{{ item.category }}</p>
    }
    @if (!!item.category && !isExpanded()) {
      <div class="side-nav__item-category--collapsed">
        <hr />
      </div>
    }
    <a
      class="side-nav__item"
      [class.side-nav__item--active]="item.isActive || (getActiveChildrenState(item) && !isExpanded())"
      (click)="onItemClick(item)"
      [matTooltip]="item.label"
      [matTooltipPosition]="'right'"
      [matTooltipDisabled]="isExpanded()"
      [matTooltipShowDelay]="100"
      [matTooltipHideDelay]="100"
      [routerLink]="item.routerLink"
      [attr.data-test-id]="'menu-' + item.viewName"
    >
      @if (item.isActive || (getActiveChildrenState(item) && !isExpanded())) {
        <span class="side-nav__item--active-indicator"></span>
      }
      @if (item.icon) {
        <mat-icon class="side-nav__item-icon" [svgIcon]="item.icon" size="20px" />
      }
      @if (isExpanded()) {
        <p class="side-nav__item-label">{{ item.label }}</p>
      }
      @if (!!item.children && isExpanded()) {
        <mat-icon
          class="side-nav__icon-toggle"
          svgIcon="chevron--down"
          [class.flipped]="item.isExpanded && isExpanded()"
        />
      }
    </a>
    @if (item.children) {
      <div
        class="side-nav__children"
        [@sidenavToggeling]="item.isExpanded && isExpanded() ? 'expanded' : 'collapsed'"
      >
        @for (child of item?.children; track child.id; let i = $index) {
          <div class="side-nav__child-container">
            <div class="side-nav__line">
              @if (item.children?.length! - 1 !== i) {
                <span class="side-nav__line--vl">
                  <svg
                    width="2"
                    height="42"
                    viewBox="0 0 2 42"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M1 41V1" stroke="#C4D5C4" stroke-linecap="round" />
                  </svg>
                  @if (!!child.children) {
                    @for (line of child.children; track line.id; let j = $index) {
                      <svg
                        [ngStyle]="{ 'top.px': 40 * (j + 1), position: 'absolute', left: 0 }"
                        width="2"
                        height="42"
                        viewBox="0 0 2 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M1 41V1" stroke="#C4D5C4" stroke-linecap="round" />
                      </svg>
                    }
                  }
                </span>
              }
              <span class="side-nav__line--hl">
                <svg
                  width="10"
                  height="22"
                  viewBox="0 0 10 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M1 1V17C1 19.2091 2.79086 21 5 21H9" stroke="#C4D5C4" stroke-linecap="round" />
                </svg>
              </span>
            </div>
            <a
              class="side-nav__item"
              [class.side-nav__item--active]="child.isActive"
              (click)="onItemClick(child)"
              [routerLink]="child.routerLink"
            >
              @if (child.isActive) {
                <span class="side-nav__item--active-indicator"></span>
              }
              @if (isExpanded()) {
                <p class="side-nav__item-label">{{ child.label }}</p>
              }
              @if (!!child.children && isExpanded()) {
                <mat-icon
                  class="side-nav__icon-toggle"
                  svgIcon="chevron--down"
                  [class.flipped]="child.isExpanded && isExpanded()"
                />
              }
            </a>
          </div>
          @if (child.children) {
            <div
              class="side-nav__grand-children"
              [@sidenavToggeling]="child.isExpanded && isExpanded() ? 'expanded' : 'collapsed'"
            >
              @for (grandChild of child.children; track grandChild.id; let i = $index) {
                <div class="side-nav__grand-child-container">
                  <div class="side-nav__line">
                    @if (child.children?.length! - 1 !== i) {
                      <span class="side-nav__line--vl">
                        <svg
                          width="2"
                          height="42"
                          viewBox="0 0 2 42"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M1 41V1" stroke="#C4D5C4" stroke-linecap="round" />
                        </svg>
                      </span>
                    }
                    <span class="side-nav__line--hl">
                      <svg
                        width="10"
                        height="22"
                        viewBox="0 0 10 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1V17C1 19.2091 2.79086 21 5 21H9"
                          stroke="#C4D5C4"
                          stroke-linecap="round"
                        />
                      </svg>
                    </span>
                  </div>
                  <a
                    class="side-nav__item"
                    [class.side-nav__item--active]="grandChild.isActive"
                    (click)="onItemClick(grandChild)"
                    [routerLink]="grandChild.routerLink"
                  >
                    @if (grandChild.isActive) {
                      <span class="side-nav__item--active-indicator"></span>
                    }
                    @if (isExpanded()) {
                      <p class="side-nav__item-label">{{ grandChild.label }}</p>
                    }
                  </a>
                </div>
              }
            </div>
          }
        }
      </div>
    }
  }
</div>
<div class="side-nav__item__toggler">
  <div
    aria-label="Expand"
    role="button"
    class="side-nav__item side-nav__item--toggler"
    (click)="toggleSideNavPinned()"
    (mouseenter)="toggleState.set('in')"
    (mouseleave)="toggleState.set('out')"
    [matTooltipDisabled]="isExpanded()"
    [matTooltipPosition]="'right'"
    [matTooltipShowDelay]="100"
    [matTooltipHideDelay]="100"
    [matTooltip]="'Expand'"
  >
    <mat-icon class="side-nav__item-icon" [svgIcon]="toggleIcon()" size="20px" />
  </div>
</div>
